import { render, staticRenderFns } from "./bRemAside.vue?vue&type=template&id=2cbe49c7&scoped=true"
import script from "./bRemAside.vue?vue&type=script&lang=js"
export * from "./bRemAside.vue?vue&type=script&lang=js"
import style0 from "./bRemAside.vue?vue&type=style&index=0&id=2cbe49c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbe49c7",
  null
  
)

export default component.exports